module.exports = __webpack_public_path__ + "img/baseCoin.cee5e37b.png";